import { useLocation } from "react-router-dom";
import { Menu } from "antd";
import type { MenuProps } from "antd";
import { routes } from "../_helpers";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import * as Icons from "@ant-design/icons";

function VerticalMenu({ onMenuClick, collapsed }: { onMenuClick?: () => void; collapsed?: boolean }) {
  let location = useLocation();
  const userData = useSelector((state: any) => state.authentication.userData);

  const getNavLinkClass = (path: any) => {
    return location.pathname === path ? "mm-active" : "";
  };

  // Helper function to get icon component from icon name string
  const getIcon = (iconName: string) => {
    const IconComponent = (Icons as any)[iconName];
    return IconComponent ? <IconComponent /> : null;
  };

  // Convert routes to Menu items format
  const menuItems: MenuProps["items"] = routes
    .filter((nav: any) => {
      // For referee and leader roles, only show competitions
      if (userData.role === "referee" || userData.role === "leader") {
        return nav.key === "competitions";
      }

      // Filter superAdmin-only routes for non-superadmin users
      if (nav.superAdminOnly && userData.role !== "superadmin") {
        return false;
      }

      // Filter admin-only routes for non-admin users (admin and superadmin can see)
      if (nav.adminOnly && userData.role !== "admin" && userData.role !== "superadmin") {
        return false;
      }

      // For admin and superadmin, show allowed items
      return true;
    })
    .map((nav: any) => {
      if (nav.childrens !== undefined && nav.childrens.length > 0) {
        // SubMenu with children
        return {
          key: nav.path,
          icon: getIcon(nav.icon),
          label: <NavLink to={nav.path}>{nav.label}</NavLink>,
          className: getNavLinkClass(nav.path),
          children: nav.childrens.map((item: any) => ({
            key: item.path,
            icon: getIcon(item.icon),
            label: <NavLink to={item.path}>{item.label}</NavLink>,
          })),
        };
      } else {
        // Regular menu item
        return {
          key: nav.path,
          icon: getIcon(nav.icon),
          label: <NavLink to={nav.path}>{nav.label}</NavLink>,
          className: getNavLinkClass(nav.path),
        };
      }
    });

  return (
    <div>
      <Menu
        mode="inline"
        onClick={onMenuClick}
        items={menuItems}
        inlineCollapsed={collapsed}
      />
    </div>
  );
}

export default VerticalMenu;
